import { ChangeDetectionStrategy, Component, HostBinding } from '@angular/core';

import { Observable, animationFrameScheduler, combineLatest, map, observeOn, tap } from 'rxjs';

import { PromotionDataKeys } from '@hdms/shared/common-types';
import { AemNavigationService } from '@hdms/shared/page-frame/data-access';
import { GlobalBanner } from '@hdms/shared/page-frame/types';
import { IconsName } from '@hdms/shared/ui-core';
import { AnalyticsService } from '@hdms/shared/util-core';

import { HeaderConfigService } from '../../services';

@Component({
  selector: 'shrd-pf-ft-global-banner',
  templateUrl: './global-banner.component.html',
  styleUrls: ['./global-banner.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class GlobalBannerComponent {
  @HostBinding('class.global-banner-container')
  private showBanner = false;

  iconName = IconsName;

  content$ = this.getContent$();

  constructor(
    private readonly aemNavigation: AemNavigationService,
    private readonly configService: HeaderConfigService,
    private readonly analyticsService: AnalyticsService
  ) {}

  trackBanner(banner: GlobalBanner, eventType: PromotionDataKeys = PromotionDataKeys.EEC_PROMOTION_CLICK): void {
    this.analyticsService.trackPromotionEvent(eventType, [
      {
        creative: 'GlobalBanner',
        id: `GlobalBanner_${banner.heading}`,
        name: banner.text
      }
    ]);
  }

  private getContent$(): Observable<GlobalBanner> {
    return combineLatest([this.aemNavigation.globalBanner$, this.configService.isCompressed$]).pipe(
      // avoid expression changed errors
      observeOn(animationFrameScheduler),
      map(([data, compressed]) => !compressed && data),
      tap(data => (this.showBanner = !!data)),
      tap(data => {
        this.showBanner && this.trackBanner(data, PromotionDataKeys.EEC_PROMOTION_IMPRESSION);
      })
    );
  }
}
